import { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { EErrorCode } from 'config/errors-codes';

export enum EErrorNotificationId {
  BAD_REQUEST = 'ERROR_BAD_REQUEST',
  UNAUTHORIZED = 'ERROR_UNAUTHORIZED',
  ACCESS_DENIED = 'ERROR_ACCESS_DENIED',
  NOT_FOUND = 'ERROR_NOT_FOUND',
  INTERNAL_ERROR = 'ERROR_INTERNAL_ERROR',
  // Session Management
  INVALID_SESSION_ID = 'ERROR_INVALID_SESSION_ID',
  CANT_LOAD_SESSION = 'ERROR_CANT_LOAD_SESSION',
  SESSION_REQUIRED = 'ERROR_SESSION_REQUIRED',
  SESSION_BRAND_REQUIRED = 'ERROR_SESSION_BRAND_REQUIRED',
  SESSION_DATA_REQUIRED = 'ERROR_SESSION_DATA_REQUIRED',
  SESSION_AUTH_REQUIRED = 'ERROR_SESSION_AUTH_REQUIRED',
  SESSION_ORGANIZER_ONLY = 'ERROR_SESSION_ORGANIZER_ONLY',
  SESSION_CREATE_FAILED = 'ERROR_SESSION_CREATE_FAILED',
  SESSION_UPDATE_FAILED = 'ERROR_SESSION_UPDATE_FAILED',
  SESSION_DELETE_FAILED = 'ERROR_SESSION_DELETE_FAILED',
  SESSION_POPUP_BLOCKED = 'ERROR_SESSION_POPUP_BLOCKED',
  SESSION_STALE_WRITE = 'ERROR_SESSION_STALE_WRITE',
  SESSION_NOT_FOUND = 'ERROR_SESSION_NOT_FOUND',
  SESSION_DELETED = 'ERROR_SESSION_DELETED',
  // Authentication
  USER_TOKENS_MISSING = 'ERROR_USER_TOKENS_MISSING',
  // Brand/Market
  INVALID_BRAND = 'ERROR_INVALID_BRAND',
  INVALID_MARKET = 'ERROR_INVALID_MARKET',
  DISABLED_MARKET = 'ERROR_DISABLED_MARKET',
  // Legal/Terms
  TERMS_OF_USE = 'ERROR_TERMS_OF_USE',
  LEGAL_DOCS = 'ERROR_LEGAL_DOCS',
  DEALER_NOT_WHITELISTED = 'ERROR_DEALER_NOT_WHITELISTED',
  // Carline Management
  CARLINE_BRAND_REQUIRED = 'ERROR_CARLINE_BRAND_REQUIRED',
  CARLINE_ID_REQUIRED = 'ERROR_CARLINE_ID_REQUIRED',
  CARLINE_DATA_REQUIRED = 'ERROR_CARLINE_DATA_REQUIRED',
  CARLINE_MARKET_REQUIRED = 'ERROR_CARLINE_MARKET_REQUIRED',
  CARLINE_FETCH_FAILED = 'ERROR_CARLINE_FETCH_FAILED',
  CARLINE_CREATE_FAILED = 'ERROR_CARLINE_CREATE_FAILED',
  CARLINE_UPDATE_FAILED = 'ERROR_CARLINE_UPDATE_FAILED',
  CARLINE_DELETE_FAILED = 'ERROR_CARLINE_DELETE_FAILED',
  // Tenant Configuration
  TENANT_CONFIG_BRAND_MARKET_REQUIRED = 'ERROR_TENANT_CONFIG_BRAND_MARKET_REQUIRED',
  TENANT_CONFIG_ID_REQUIRED = 'ERROR_TENANT_CONFIG_ID_REQUIRED',
  TENANT_CONFIG_DATA_REQUIRED = 'ERROR_TENANT_CONFIG_DATA_REQUIRED',
  TENANT_CONFIG_NOT_FOUND = 'ERROR_TENANT_CONFIG_NOT_FOUND',
  TENANT_CONFIG_ALREADY_EXISTS = 'ERROR_TENANT_CONFIG_ALREADY_EXISTS',
  TENANT_CONFIG_FETCH_FAILED = 'ERROR_TENANT_CONFIG_FETCH_FAILED',
  TENANT_CONFIG_CREATE_FAILED = 'ERROR_TENANT_CONFIG_CREATE_FAILED',
  TENANT_CONFIG_UPDATE_FAILED = 'ERROR_TENANT_CONFIG_UPDATE_FAILED',
  TENANT_CONFIG_DELETE_FAILED = 'ERROR_TENANT_CONFIG_DELETE_FAILED',
  // Analytics
  ANALYTICS_METRIC_REQUIRED = 'ERROR_ANALYTICS_METRIC_REQUIRED',
  ANALYTICS_METRIC_INVALID = 'ERROR_ANALYTICS_METRIC_INVALID',
  ANALYTICS_PAYLOAD_REQUIRED = 'ERROR_ANALYTICS_PAYLOAD_REQUIRED',
  ANALYTICS_PAYLOAD_INVALID = 'ERROR_ANALYTICS_PAYLOAD_INVALID',
  ANALYTICS_CREATE_FAILED = 'ERROR_ANALYTICS_CREATE_FAILED',
  // Signaling/WebRTC
  SIGNALING_BODY_REQUIRED = 'ERROR_SIGNALING_BODY_REQUIRED',
  SIGNALING_EVENT_INVALID = 'ERROR_SIGNALING_EVENT_INVALID',
  SIGNALING_CONNECTION_FAILED = 'ERROR_SIGNALING_CONNECTION_FAILED',
  SIGNALING_HANDSHAKE_FAILED = 'ERROR_SIGNALING_HANDSHAKE_FAILED',
  SIGNALING_RELAY_FAILED = 'ERROR_SIGNALING_RELAY_FAILED',
  // Notifications
  NOTIFICATION_CREATE_FAILED = 'ERROR_NOTIFICATION_CREATE_FAILED',
  // Scheduling
  SCHEDULE_OVERLAP = 'ERROR_SCHEDULE_OVERLAP',
  SCHEDULE_START_TIME_REQUIRED = 'ERROR_SCHEDULE_START_TIME_REQUIRED',
  SCHEDULE_START_TIME_INVALID = 'ERROR_SCHEDULE_START_TIME_INVALID',
  SCHEDULE_END_TIME_INVALID = 'ERROR_SCHEDULE_END_TIME_INVALID',
  SCHEDULE_LIMIT_INVALID = 'ERROR_SCHEDULE_LIMIT_INVALID',
  SCHEDULE_SESSION_ID_REQUIRED = 'ERROR_SCHEDULE_SESSION_ID_REQUIRED',
  SCHEDULE_SESSION_DATA_REQUIRED = 'ERROR_SCHEDULE_SESSION_DATA_REQUIRED',
  SCHEDULE_NOT_AUTHORIZED = 'ERROR_SCHEDULE_NOT_AUTHORIZED',
  SCHEDULE_CREATE_FAILED = 'ERROR_SCHEDULE_CREATE_FAILED',
  SCHEDULE_UPDATE_FAILED = 'ERROR_SCHEDULE_UPDATE_FAILED',
  SCHEDULE_DELETE_FAILED = 'ERROR_SCHEDULE_DELETE_FAILED',
  SCHEDULE_FETCH_FAILED = 'ERROR_SCHEDULE_FETCH_FAILED',
  // Tenant Management
  TENANT_NAME_REQUIRED = 'ERROR_TENANT_NAME_REQUIRED',
  TENANT_FETCH_FAILED = 'ERROR_TENANT_FETCH_FAILED',
  TENANT_CREATE_FAILED = 'ERROR_TENANT_CREATE_FAILED',
  // Vehicle
  INVALID_CODE = 'ERROR_INVALID_CODE',
  VEHICLE_NOT_FOUND = 'ERROR_VEHICLE_NOT_FOUND',
  WLTP_INVALID = 'ERROR_WLTP_INVALID',
  OUTDATED_VEHICLE = 'ERROR_OUTDATED_VEHICLE',
  UPSTREAM_ERROR = 'ERROR_UPSTREAM_ERROR',
  UPSTREAM_TIMEOUT = 'ERROR_UPSTREAM_TIMEOUT',
  // Streaming
  GENERAL_STREAM_ERROR = 'ERROR_GENERAL_STREAM_ERROR',
  STREAM_DISCONNECTED = 'ERROR_STREAM_DISCONNECTED',
  STREAM_TIMEOUT = 'ERROR_STREAM_TIMEOUT',
  // Showroom/AVE
  UNKNOWN_EXCEPTION = 'ERROR_UNKNOWN_EXCEPTION',
  AVE_CAR_NOT_INSTALLED = 'ERROR_AVE_CAR_NOT_INSTALLED',
  AVE_ENVIRONMENT_NOT_INSTALLED = 'ERROR_AVE_ENVIRONMENT_NOT_INSTALLED',
  NO_INSTANCES_AVAILABLE = 'ERROR_NO_INSTANCES_AVAILABLE',
  PR_STRING_NOT_PROVIDED = 'ERROR_PR_STRING_NOT_PROVIDED',
  CONFIGURATION_ERROR = 'ERROR_CONFIGURATION_ERROR',
  BRAND_NOT_PROVIDED = 'ERROR_BRAND_NOT_PROVIDED',
  BRAND_NOT_SUPPORTED = 'ERROR_BRAND_NOT_SUPPORTED',
  SERVICE_NOT_PROVIDED = 'ERROR_SERVICE_NOT_PROVIDED',
  MARKET_NOT_PROVIDED = 'ERROR_MARKET_NOT_PROVIDED',
  // Images
  IMAGES_NOT_ENABLED = 'ERROR_2D_NOT_ENABLED',
  IMAGES_NOT_AVAILABLE = 'ERROR_IMAGES_NOT_AVAILABLE',
  // DGA
  DGA_ERROR = 'ERROR_DGA_ERROR',
  DGA_AUTH_ERROR = 'ERROR_DGA_AUTH_ERROR',
  // ICE Servers
  ICE_SERVERS_FAILED = 'ERROR_ICE_SERVERS_FAILED',
  // Energy Label
  ENERGY_LABEL_NOT_AVAILABLE = 'WARN_ENERGY_LABEL_UNAVAILABLE',
}

export type IErrorCollection = {
  [key in EErrorCode]: {
    title: () => MessageDescriptor;
    message: () => MessageDescriptor;
    notificationId: EErrorNotificationId;
  };
};

export const errorCollection: IErrorCollection = {
  // regular HTTP status codes
  [EErrorCode.BAD_REQUEST]: {
    title: () => msg`Bad Request`,
    message: () => msg`The request is invalid. Please check the parameters and try again.`,
    notificationId: EErrorNotificationId.BAD_REQUEST,
  },
  [EErrorCode.UNAUTHORIZED]: {
    title: () => msg`Unauthorized`,
    message: () => msg`You are not authorized to access the requested page.`,
    notificationId: EErrorNotificationId.UNAUTHORIZED,
  },
  [EErrorCode.ACCESS_DENIED]: {
    title: () => msg`Access denied`,
    message: () => msg`You do not have permission to access the requested page.`,
    notificationId: EErrorNotificationId.ACCESS_DENIED,
  },
  [EErrorCode.NOT_FOUND]: {
    title: () => msg`Not found`,
    message: () =>
      msg`The page you are looking for does not exist. You may have mistyped the address or the page may have moved.`,
    notificationId: EErrorNotificationId.NOT_FOUND,
  },
  [EErrorCode.INTERNAL_ERROR]: {
    title: () => msg`Internal error`,
    message: () => msg`An internal error occurred. Please try again later.`,
    notificationId: EErrorNotificationId.INTERNAL_ERROR,
  },
  // custom error codes that may prefix the HTTP status code
  [EErrorCode.INVALID_SESSION_ID]: {
    title: () => msg`Invalid session ID`,
    message: () => msg`Your session ID is not properly formatted.`,
    notificationId: EErrorNotificationId.INVALID_SESSION_ID,
  },
  [EErrorCode.CANT_LOAD_SESSION]: {
    title: () => msg`Cannot load session`,
    message: () => msg`Error loading session information from the server.`,
    notificationId: EErrorNotificationId.CANT_LOAD_SESSION,
  },
  [EErrorCode.SESSION_REQUIRED]: {
    title: () => msg`Session ID required`,
    message: () => msg`Session ID is required to perform this action.`,
    notificationId: EErrorNotificationId.SESSION_REQUIRED,
  },
  [EErrorCode.SESSION_BRAND_REQUIRED]: {
    title: () => msg`Brand required`,
    message: () => msg`Brand is required to create a session.`,
    notificationId: EErrorNotificationId.SESSION_BRAND_REQUIRED,
  },
  [EErrorCode.SESSION_DATA_REQUIRED]: {
    title: () => msg`Session data required`,
    message: () => msg`Session data is required to update the session.`,
    notificationId: EErrorNotificationId.SESSION_DATA_REQUIRED,
  },
  [EErrorCode.SESSION_AUTH_REQUIRED]: {
    title: () => msg`Authentication required`,
    message: () => msg`You must be authenticated to end this session.`,
    notificationId: EErrorNotificationId.SESSION_AUTH_REQUIRED,
  },
  [EErrorCode.SESSION_ORGANIZER_ONLY]: {
    title: () => msg`Organizer only`,
    message: () => msg`Only the session organizer can perform this action.`,
    notificationId: EErrorNotificationId.SESSION_ORGANIZER_ONLY,
  },
  [EErrorCode.SESSION_CREATE_FAILED]: {
    title: () => msg`Session creation failed`,
    message: () => msg`Failed to create the session. Please try again.`,
    notificationId: EErrorNotificationId.SESSION_CREATE_FAILED,
  },
  [EErrorCode.SESSION_UPDATE_FAILED]: {
    title: () => msg`Session update failed`,
    message: () => msg`Failed to update the session. Please try again.`,
    notificationId: EErrorNotificationId.SESSION_UPDATE_FAILED,
  },
  [EErrorCode.SESSION_DELETE_FAILED]: {
    title: () => msg`Session deletion failed`,
    message: () => msg`Failed to delete the session. Please try again.`,
    notificationId: EErrorNotificationId.SESSION_DELETE_FAILED,
  },
  [EErrorCode.SESSION_POPUP_BLOCKED]: {
    title: () => msg`Popup blocked`,
    message: () => msg`Your browser blocked the session window. Please allow popups for this site and try again.`,
    notificationId: EErrorNotificationId.SESSION_POPUP_BLOCKED,
  },
  [EErrorCode.SESSION_STALE_WRITE]: {
    title: () => msg`Stale write`,
    message: () => msg`Your changes could not be saved. Please refresh and try again.`,
    notificationId: EErrorNotificationId.SESSION_STALE_WRITE,
  },
  [EErrorCode.SESSION_NOT_FOUND]: {
    title: () => msg`Session not found`,
    message: () => msg`The session was cancelled or rescheduled. Please contact your dealer for details.`,
    notificationId: EErrorNotificationId.SESSION_NOT_FOUND,
  },
  [EErrorCode.SESSION_DELETED]: {
    title: () => msg`Session Unavailable`,
    message: () => msg`The session was cancelled or rescheduled. Please contact your dealer for details.`,
    notificationId: EErrorNotificationId.SESSION_DELETED,
  },
  [EErrorCode.USER_TOKENS_MISSING]: {
    title: () => msg`User token missing`,
    message: () => msg`Brand or market association missing in your user account.`,
    notificationId: EErrorNotificationId.USER_TOKENS_MISSING,
  },
  [EErrorCode.INVALID_BRAND]: {
    title: () => msg`Invalid brand`,
    message: () => msg`Unknown brand provided in the URL.`,
    notificationId: EErrorNotificationId.INVALID_BRAND,
  },
  [EErrorCode.INVALID_MARKET]: {
    title: () => msg`Invalid market`,
    message: () => msg`Unknown market provided in the URL.`,
    notificationId: EErrorNotificationId.INVALID_MARKET,
  },
  [EErrorCode.DISABLED_MARKET]: {
    title: () => msg`Disabled market`,
    message: () => msg`Your market hasn't been enabled in 3D Exhibition yet.`,
    notificationId: EErrorNotificationId.DISABLED_MARKET,
  },
  [EErrorCode.TERMS_OF_USE]: {
    title: () => msg`Cannot load Terms of Use`,
    message: () => msg`Error loading terms of use from the server.`,
    notificationId: EErrorNotificationId.TERMS_OF_USE,
  },
  [EErrorCode.LEGAL_DOCS]: {
    title: () => msg`Cannot load the legal documents`,
    message: () => msg`Error loading the legal documents from the server.`,
    notificationId: EErrorNotificationId.LEGAL_DOCS,
  },
  // custom error codes for vehicle selection
  [EErrorCode.INVALID_CODE]: {
    title: () => msg`Invalid Code`,
    message: () =>
      msg`The entered code is invalid. Its length does not match the requirements and / or it contains invalid characters.`,
    notificationId: EErrorNotificationId.INVALID_CODE,
  },
  [EErrorCode.VEHICLE_NOT_FOUND]: {
    title: () => msg`Vehicle not found`,
    message: () =>
      msg`The vehicle for the provided code could not be found or its configuration data is unavailable. Please verify the code and try again.`,
    notificationId: EErrorNotificationId.VEHICLE_NOT_FOUND,
  },
  [EErrorCode.WLTP_INVALID]: {
    title: () => msg`WLTP invalid`,
    message: () =>
      msg`The vehicle for the entered code does not have appropriate WLTP data for this market and cannot be displayed.`,
    notificationId: EErrorNotificationId.WLTP_INVALID,
  },
  [EErrorCode.OUTDATED_VEHICLE]: {
    title: () => msg`Outdated vehicle`,
    message: () => msg`Vehicle models older than two years cannot be displayed.`,
    notificationId: EErrorNotificationId.OUTDATED_VEHICLE,
  },
  [EErrorCode.UPSTREAM_ERROR]: {
    title: () => msg`Vehicle data service unavailable`,
    message: () => msg`Vehicle data service is temporarily unavailable. Please try again later.`,
    notificationId: EErrorNotificationId.UPSTREAM_ERROR,
  },
  [EErrorCode.UPSTREAM_TIMEOUT]: {
    title: () => msg`Vehicle data service timeout`,
    message: () => msg`Vehicle data service is temporarily unavailable. Please try again later.`,
    notificationId: EErrorNotificationId.UPSTREAM_TIMEOUT,
  },
  [EErrorCode.GENERAL_STREAM_ERROR]: {
    title: () => msg`Visualization error`,
    message: () => msg`An internal error occurred and the 3D stream cannot be started.`,
    notificationId: EErrorNotificationId.GENERAL_STREAM_ERROR,
  },
  [EErrorCode.STREAM_DISCONNECTED]: {
    title: () => msg`3D stream disconnected`,
    message: () => msg`3D View is unavailable now. Please try again later.`,
    notificationId: EErrorNotificationId.STREAM_DISCONNECTED,
  },
  [EErrorCode.STREAM_TIMEOUT]: {
    title: () => msg`3D stream timed out`,
    message: () => msg`The 3D session timed out. Continuing in 2D mode.`,
    notificationId: EErrorNotificationId.STREAM_TIMEOUT,
  },
  // Showroom error code mapping
  [EErrorCode.UNKNOWN_EXCEPTION]: {
    // using GENERAL_STREAM_ERROR translation
    title: () => msg`Visualization error`,
    message: () => msg`An internal error occurred and the 3D stream cannot be started.`,
    notificationId: EErrorNotificationId.UNKNOWN_EXCEPTION,
  },
  [EErrorCode.AVE_CAR_NOT_INSTALLED]: {
    title: () => msg`Vehicle not installed`,
    message: () => msg`The vehicle you requested is currently not available for visualization.`,
    notificationId: EErrorNotificationId.AVE_CAR_NOT_INSTALLED,
  },
  [EErrorCode.AVE_ENVIRONMENT_NOT_INSTALLED]: {
    title: () => msg`Environment not installed`,
    message: () => msg`The requested environment is not installed or available for visualization.`,
    notificationId: EErrorNotificationId.AVE_ENVIRONMENT_NOT_INSTALLED,
  },
  [EErrorCode.NO_INSTANCES_AVAILABLE]: {
    title: () => msg`No instance available`,
    message: () =>
      msg`There is currently no streaming capacity available to fulfill your request. Please try again in a few moments.`,
    notificationId: EErrorNotificationId.NO_INSTANCES_AVAILABLE,
  },
  [EErrorCode.PR_STRING_NOT_PROVIDED]: {
    title: () => msg`PR string missing`,
    message: () => msg`A required PR string was not provided. Please check your configuration and try again.`,
    notificationId: EErrorNotificationId.PR_STRING_NOT_PROVIDED,
  },
  [EErrorCode.CONFIGURATION_ERROR]: {
    title: () => msg`Configuration error`,
    message: () => msg`A configuration error occurred. Please contact support or check your setup.`,
    notificationId: EErrorNotificationId.CONFIGURATION_ERROR,
  },
  [EErrorCode.BRAND_NOT_PROVIDED]: {
    title: () => msg`Brand missing`,
    message: () => msg`No brand was provided. Please check your configuration and try again.`,
    notificationId: EErrorNotificationId.BRAND_NOT_PROVIDED,
  },
  [EErrorCode.BRAND_NOT_SUPPORTED]: {
    title: () => msg`Brand not supported`,
    message: () => msg`The selected brand is not supported in this environment.`,
    notificationId: EErrorNotificationId.BRAND_NOT_SUPPORTED,
  },
  // Carline Management errors
  [EErrorCode.CARLINE_BRAND_REQUIRED]: {
    title: () => msg`Brand required`,
    message: () => msg`Brand is required to manage carlines.`,
    notificationId: EErrorNotificationId.CARLINE_BRAND_REQUIRED,
  },
  [EErrorCode.CARLINE_ID_REQUIRED]: {
    title: () => msg`Carline ID required`,
    message: () => msg`Carline ID is required to perform this action.`,
    notificationId: EErrorNotificationId.CARLINE_ID_REQUIRED,
  },
  [EErrorCode.CARLINE_DATA_REQUIRED]: {
    title: () => msg`Carline data required`,
    message: () => msg`Carline data is required to create or update a carline.`,
    notificationId: EErrorNotificationId.CARLINE_DATA_REQUIRED,
  },
  [EErrorCode.CARLINE_MARKET_REQUIRED]: {
    title: () => msg`Market required`,
    message: () => msg`Market is required to manage carlines.`,
    notificationId: EErrorNotificationId.CARLINE_MARKET_REQUIRED,
  },
  [EErrorCode.CARLINE_FETCH_FAILED]: {
    title: () => msg`Carline fetch failed`,
    message: () => msg`Failed to fetch carline information. Please try again.`,
    notificationId: EErrorNotificationId.CARLINE_FETCH_FAILED,
  },
  [EErrorCode.CARLINE_CREATE_FAILED]: {
    title: () => msg`Carline creation failed`,
    message: () => msg`Failed to create the carline. Please try again.`,
    notificationId: EErrorNotificationId.CARLINE_CREATE_FAILED,
  },
  [EErrorCode.CARLINE_UPDATE_FAILED]: {
    title: () => msg`Carline update failed`,
    message: () => msg`Failed to update the carline. Please try again.`,
    notificationId: EErrorNotificationId.CARLINE_UPDATE_FAILED,
  },
  [EErrorCode.CARLINE_DELETE_FAILED]: {
    title: () => msg`Carline deletion failed`,
    message: () => msg`Failed to delete the carline. Please try again.`,
    notificationId: EErrorNotificationId.CARLINE_DELETE_FAILED,
  },
  // Tenant Configuration errors
  [EErrorCode.TENANT_CONFIG_BRAND_MARKET_REQUIRED]: {
    title: () => msg`Brand and market required`,
    message: () => msg`Both brand and market are required for tenant configuration.`,
    notificationId: EErrorNotificationId.TENANT_CONFIG_BRAND_MARKET_REQUIRED,
  },
  [EErrorCode.TENANT_CONFIG_ID_REQUIRED]: {
    title: () => msg`Configuration ID required`,
    message: () => msg`Tenant configuration ID is required to perform this action.`,
    notificationId: EErrorNotificationId.TENANT_CONFIG_ID_REQUIRED,
  },
  [EErrorCode.TENANT_CONFIG_DATA_REQUIRED]: {
    title: () => msg`Configuration data required`,
    message: () => msg`Tenant configuration data is required to create or update the configuration.`,
    notificationId: EErrorNotificationId.TENANT_CONFIG_DATA_REQUIRED,
  },
  [EErrorCode.TENANT_CONFIG_NOT_FOUND]: {
    title: () => msg`Configuration not found`,
    message: () => msg`No tenant configuration is available for this brand and market.`,
    notificationId: EErrorNotificationId.TENANT_CONFIG_NOT_FOUND,
  },
  [EErrorCode.TENANT_CONFIG_ALREADY_EXISTS]: {
    title: () => msg`Configuration exists`,
    message: () => msg`A tenant configuration already exists for this brand and market.`,
    notificationId: EErrorNotificationId.TENANT_CONFIG_ALREADY_EXISTS,
  },
  [EErrorCode.TENANT_CONFIG_FETCH_FAILED]: {
    title: () => msg`Configuration fetch failed`,
    message: () => msg`Failed to fetch tenant configuration. Please try again.`,
    notificationId: EErrorNotificationId.TENANT_CONFIG_FETCH_FAILED,
  },
  [EErrorCode.TENANT_CONFIG_CREATE_FAILED]: {
    title: () => msg`Configuration creation failed`,
    message: () => msg`Failed to create tenant configuration. Please try again.`,
    notificationId: EErrorNotificationId.TENANT_CONFIG_CREATE_FAILED,
  },
  [EErrorCode.TENANT_CONFIG_UPDATE_FAILED]: {
    title: () => msg`Configuration update failed`,
    message: () => msg`Failed to update tenant configuration. Please try again.`,
    notificationId: EErrorNotificationId.TENANT_CONFIG_UPDATE_FAILED,
  },
  [EErrorCode.TENANT_CONFIG_DELETE_FAILED]: {
    title: () => msg`Configuration deletion failed`,
    message: () => msg`Failed to delete tenant configuration. Please try again.`,
    notificationId: EErrorNotificationId.TENANT_CONFIG_DELETE_FAILED,
  },
  // Analytics errors
  [EErrorCode.ANALYTICS_METRIC_REQUIRED]: {
    title: () => msg`Metric required`,
    message: () => msg`Analytics metric is required to record an event.`,
    notificationId: EErrorNotificationId.ANALYTICS_METRIC_REQUIRED,
  },
  [EErrorCode.ANALYTICS_METRIC_INVALID]: {
    title: () => msg`Invalid metric`,
    message: () => msg`The analytics metric provided is not valid.`,
    notificationId: EErrorNotificationId.ANALYTICS_METRIC_INVALID,
  },
  [EErrorCode.ANALYTICS_PAYLOAD_REQUIRED]: {
    title: () => msg`Payload required`,
    message: () => msg`Analytics payload cannot be empty.`,
    notificationId: EErrorNotificationId.ANALYTICS_PAYLOAD_REQUIRED,
  },
  [EErrorCode.ANALYTICS_PAYLOAD_INVALID]: {
    title: () => msg`Invalid payload`,
    message: () => msg`The analytics payload is not valid for the provided metric.`,
    notificationId: EErrorNotificationId.ANALYTICS_PAYLOAD_INVALID,
  },
  [EErrorCode.ANALYTICS_CREATE_FAILED]: {
    title: () => msg`Analytics recording failed`,
    message: () => msg`Failed to record analytics event. Please try again.`,
    notificationId: EErrorNotificationId.ANALYTICS_CREATE_FAILED,
  },
  // Signaling/WebRTC errors
  [EErrorCode.SIGNALING_BODY_REQUIRED]: {
    title: () => msg`Request body required`,
    message: () => msg`Request body is required for signaling operations.`,
    notificationId: EErrorNotificationId.SIGNALING_BODY_REQUIRED,
  },
  [EErrorCode.SIGNALING_EVENT_INVALID]: {
    title: () => msg`Invalid event`,
    message: () => msg`Received an invalid or unsupported signaling event.`,
    notificationId: EErrorNotificationId.SIGNALING_EVENT_INVALID,
  },
  [EErrorCode.SIGNALING_CONNECTION_FAILED]: {
    title: () => msg`Connection failed`,
    message: () => msg`Failed to establish signaling connection. Please try again.`,
    notificationId: EErrorNotificationId.SIGNALING_CONNECTION_FAILED,
  },
  [EErrorCode.SIGNALING_HANDSHAKE_FAILED]: {
    title: () => msg`Handshake failed`,
    message: () => msg`WebRTC handshake failed. Please check your connection.`,
    notificationId: EErrorNotificationId.SIGNALING_HANDSHAKE_FAILED,
  },
  [EErrorCode.SIGNALING_RELAY_FAILED]: {
    title: () => msg`Message relay failed`,
    message: () => msg`Failed to relay signaling message. Please try again.`,
    notificationId: EErrorNotificationId.SIGNALING_RELAY_FAILED,
  },
  // Notification errors
  [EErrorCode.NOTIFICATION_CREATE_FAILED]: {
    title: () => msg`Notification failed`,
    message: () => msg`Failed to create notification. Please try again.`,
    notificationId: EErrorNotificationId.NOTIFICATION_CREATE_FAILED,
  },
  // Scheduling errors
  [EErrorCode.SCHEDULE_START_TIME_REQUIRED]: {
    title: () => msg`Start time required`,
    message: () => msg`Scheduled start time is required to create a session.`,
    notificationId: EErrorNotificationId.SCHEDULE_START_TIME_REQUIRED,
  },
  [EErrorCode.SCHEDULE_START_TIME_INVALID]: {
    title: () => msg`Invalid start time`,
    message: () => msg`The scheduled start time format is invalid. Please use ISO 8601 format.`,
    notificationId: EErrorNotificationId.SCHEDULE_START_TIME_INVALID,
  },
  [EErrorCode.SCHEDULE_END_TIME_INVALID]: {
    title: () => msg`Invalid end time`,
    message: () => msg`The scheduled end time format is invalid. Please use ISO 8601 format.`,
    notificationId: EErrorNotificationId.SCHEDULE_END_TIME_INVALID,
  },
  [EErrorCode.SCHEDULE_LIMIT_INVALID]: {
    title: () => msg`Invalid limit`,
    message: () => msg`The limit must be a positive integer.`,
    notificationId: EErrorNotificationId.SCHEDULE_LIMIT_INVALID,
  },
  [EErrorCode.SCHEDULE_SESSION_ID_REQUIRED]: {
    title: () => msg`Session ID required`,
    message: () => msg`Session ID is required to perform this scheduling action.`,
    notificationId: EErrorNotificationId.SCHEDULE_SESSION_ID_REQUIRED,
  },
  [EErrorCode.SCHEDULE_SESSION_DATA_REQUIRED]: {
    title: () => msg`Session data required`,
    message: () => msg`Session data is required to create or update a scheduled session.`,
    notificationId: EErrorNotificationId.SCHEDULE_SESSION_DATA_REQUIRED,
  },
  [EErrorCode.SCHEDULE_NOT_AUTHORIZED]: {
    title: () => msg`Not authorized`,
    message: () => msg`You are not authorized to modify this scheduled session.`,
    notificationId: EErrorNotificationId.SCHEDULE_NOT_AUTHORIZED,
  },
  [EErrorCode.SCHEDULE_CREATE_FAILED]: {
    title: () => msg`Schedule creation failed`,
    message: () => msg`Failed to create scheduled session. Please try again.`,
    notificationId: EErrorNotificationId.SCHEDULE_CREATE_FAILED,
  },
  [EErrorCode.SCHEDULE_UPDATE_FAILED]: {
    title: () => msg`Schedule update failed`,
    message: () => msg`Failed to update scheduled session. Please try again.`,
    notificationId: EErrorNotificationId.SCHEDULE_UPDATE_FAILED,
  },
  [EErrorCode.SCHEDULE_DELETE_FAILED]: {
    title: () => msg`Schedule deletion failed`,
    message: () => msg`Failed to delete scheduled session. Please try again.`,
    notificationId: EErrorNotificationId.SCHEDULE_DELETE_FAILED,
  },
  [EErrorCode.SCHEDULE_FETCH_FAILED]: {
    title: () => msg`Schedule fetch failed`,
    message: () => msg`Failed to fetch scheduled sessions. Please try again.`,
    notificationId: EErrorNotificationId.SCHEDULE_FETCH_FAILED,
  },
  // Tenant Management errors
  [EErrorCode.TENANT_NAME_REQUIRED]: {
    title: () => msg`Tenant name required`,
    message: () => msg`Tenant name is required to create a tenant.`,
    notificationId: EErrorNotificationId.TENANT_NAME_REQUIRED,
  },
  [EErrorCode.TENANT_FETCH_FAILED]: {
    title: () => msg`Tenant fetch failed`,
    message: () => msg`Failed to fetch tenant information. Please try again.`,
    notificationId: EErrorNotificationId.TENANT_FETCH_FAILED,
  },
  [EErrorCode.TENANT_CREATE_FAILED]: {
    title: () => msg`Tenant creation failed`,
    message: () => msg`Failed to create tenant. Please try again.`,
    notificationId: EErrorNotificationId.TENANT_CREATE_FAILED,
  },
  // ICE Servers errors
  [EErrorCode.ICE_SERVERS_FAILED]: {
    title: () => msg`ICE servers unavailable`,
    message: () => msg`Failed to retrieve ICE server configuration. Please try again.`,
    notificationId: EErrorNotificationId.ICE_SERVERS_FAILED,
  },
  [EErrorCode.SERVICE_NOT_PROVIDED]: {
    title: () => msg`Service missing`,
    message: () => msg`A required service was not provided. Please check your configuration and try again.`,
    notificationId: EErrorNotificationId.SERVICE_NOT_PROVIDED,
  },
  [EErrorCode.MARKET_NOT_PROVIDED]: {
    title: () => msg`Market missing`,
    message: () => msg`No market was provided. Please check your configuration and try again.`,
    notificationId: EErrorNotificationId.MARKET_NOT_PROVIDED,
  },
  [EErrorCode.IMAGES_NOT_AVAILABLE]: {
    title: () => msg`Images not available`,
    message: () =>
      msg`An error occurred while fetching the vehicle images. You can still start the session to use 3D visualization.`,
    notificationId: EErrorNotificationId.IMAGES_NOT_AVAILABLE,
  },
  [EErrorCode.IMAGES_NOT_ENABLED]: {
    title: () => msg`2D feature not enabled`,
    message: () =>
      msg`Displaying 2D content is not enabled for your tenant. You can still start the session to use 3D visualization.`,
    notificationId: EErrorNotificationId.IMAGES_NOT_ENABLED,
  },
  [EErrorCode.DGA_ERROR]: {
    title: () => msg`Error creating Digital Giveaway`,
    message: () => msg`An unknown error occurred while creating the Digital Giveaway.`,
    notificationId: EErrorNotificationId.DGA_ERROR,
  },
  [EErrorCode.DGA_AUTH_ERROR]: {
    title: () => msg`Digital Giveaway authentication error`,
    message: () => msg`An authentication error occurred while creating the Digital Giveaway. Please try again later.`,
    notificationId: EErrorNotificationId.DGA_AUTH_ERROR,
  },
  [EErrorCode.SCHEDULE_OVERLAP]: {
    title: () => msg`Time slot unavailable`,
    // SYNC: fallback when conflict time formatting fails (see
    // src/containers/SharingDashboard/Scheduler.tsx:98-100)
    message: () =>
      msg`This time conflicts with an existing session. Please ensure that your next appointment is scheduled at least 20 minutes after the previous one.`,
    notificationId: EErrorNotificationId.SCHEDULE_OVERLAP,
  },
  [EErrorCode.DEALER_NOT_WHITELISTED]: {
    title: () => msg`Access Restricted`,
    message: () =>
      msg`Your dealer account is not authorized to access this application. Please contact your administrator for access.`,
    notificationId: EErrorNotificationId.DEALER_NOT_WHITELISTED,
  },
  // Energy Label errors
  [EErrorCode.ENERGY_LABEL_NOT_AVAILABLE]: {
    title: () => msg`Energy label unavailable`,
    message: () => msg`No energy label image could be found for this vehicle.`,
    notificationId: EErrorNotificationId.ENERGY_LABEL_NOT_AVAILABLE,
  },
};
